/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class PrepaidOrderApi {
    static getInstance() {
        if (!this.instance) this.instance = new PrepaidOrderApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取预付款订单列表
    async getPrepaidOrderList (param, page_num, page_size){
        let url = `/api/order/prepaid/head/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取预付款订单行列表
    async getPrepaidOrderLine (param){
        let url = `/api/order/prepaid/line/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 变更预付款订单为无效
    async changeStatus (param, id){
        let url = `/api/order/prepaid/head/${id}/status`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 更新预付款订单备注
    async editRemark (param, id){
        let url = `/api/order/prepaid/head/${id}/instruction`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 发送预付发票
    async sendInvoice (id){
        let url = `/api/order/module/email/prepaid/invoice/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 预付款订单发货
    async orderDelivery (param,id,prepaid_order_id){
        let url = `/api/order/stock/out/${id}/courier?prepaid_order_id=${prepaid_order_id}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    
    // 解绑出库单
    async unbindOutboundOrder (param,prepaid_order_id){
        let url = `/api/order/prepaid/head/unbind/delivery/${prepaid_order_id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

}

export {
    PrepaidOrderApi
}